<!--
  功能：功能描述
  作者：wangwenhao
  邮箱：wangwenhao@gw.com.cn
  时间：
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
	<div :class="themeStyleVs==2?'black_version':''">
		<div class="advertisement-img">
			<img :src="imgUrl" alt="" class="imgInfo">
		</div>
		<div class="vip-text">当前页面需要解锁vip权限才可查看</div>
		<div class="vip-button" @click="gotoVipShowInfo">
			了解VIP权益
		</div>
	</div>
</template>

<script>
	export default {
		// 组件名称
		name: 'demo',
		// 组件参数 接收来自父组件的数据
		props: {},
		// 局部注册的组件
		components: {},
		// 组件状态值
		data() {
			return {
				imgUrl: window.config.vipImgUrl,
				themeStyleVs: 1,
				dzhadid:'',
				channel:''
			};
		},
		// 计算属性
		computed: {},
		// 侦听器
		watch: {},
		// 组件方法
		methods: {
			// 点击跳转vip
			gotoVipShowInfo:function(){
				window.location.href = window.config.nonVipUrl+'&dzhadid='+this.dzhadid+'&channel='+this.channel;
			}
		},
		// 以下是生命周期钩子   注：没用到的钩子请自行删除
		/**
		 * 在实例初始化之后，组件属性计算之前，如data属性等
		 */
		beforeCreate() {},
		/**
		 * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
		 */
		created() {
			this.dzhadid = this.$route.query.dzhadid;
			this.channel = this.$route.query.channel;
		},
		/**
		 * 在挂载开始之前被调用：相关的 render 函数首次被调用。
		 */
		beforeMount() {},
		/**
		 * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
		 * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
		 */
		mounted() {
			this.themeStyleVs = Number(this.$route.query.themeStyleVs);
			if (this.themeStyleVs === 2) {
			document.querySelector('body').setAttribute('style', 'background-color:#0C0E12;');
			document.querySelector('#app').setAttribute('style', 'background-color:#0C0E12;');
			}
		},
		/**
		 * 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
		 * 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
		 */
		beforeUpdate() {},
		/**
		 * 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
		 * 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
		 */
		updated() {},
		/**
		 * keep-alive 组件激活时调用。 仅针对keep-alive 组件有效
		 */
		activated() {},
		/**
		 * keep-alive 组件停用时调用。 仅针对keep-alive 组件有效
		 */
		deactivated() {},
		/**
		 * 实例销毁之前调用。在这一步，实例仍然完全可用。
		 */
		beforeDestroy() {},
		/**
		 * Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，
		 * 所有的事件监听器会被移除，所有的子实例也会被销毁。
		 */
		destroyed() {},
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--使用了scoped属性之后，父组件的style样式将不会渗透到子组件中，-->
<!--然而子组件的根节点元素会同时被设置了scoped的父css样式和设置了scoped的子css样式影响，-->
<!--这么设计的目的是父组件可以对子组件根元素进行布局。-->
<style scoped lang="less">
.black_version{
	background: #0c0e12;
}
.advertisement-img {
	// width: 100%;
	height: 197px;
	margin: 16px 32px;
	border-radius: 9px;
	overflow: hidden;
	.imgInfo {
		width: 100%;
		height: 100%;
	}
}
// 文字
.vip-text {
	color: var(--colours-text-2, #555);
	font-size: 14px;
	font-weight: 400;
	text-align: center;
	margin-bottom: 16px;
}
// 按钮文字
.vip-button {
	height: 40px;
	margin: 0 32px;
	line-height: 40px;
	text-align: center;
	border-radius: 6px;
	background: #A96C35;
	font-size: 14px;
	color: #ffffff;
	font-weight: 600;
	
}
</style>
